import React, { Suspense, lazy, useEffect } from 'react';
import { UrgencyBar } from './components/UrgencyBar';
import { Hero } from './components/Hero';
import { META_PIXEL_ID } from './data/checkout';
import { initMetaPixel } from './utils/metaPixel';

// Todo lo que está bajo el pliegue se carga en un chunk aparte:
// el lead ve el hero de inmediato y el resto llega en segundo plano.
const BelowFold = lazy(() => import('./components/BelowFold').then(module => ({
  default: module.BelowFold
})));
export function App() {
  useEffect(() => {
    initMetaPixel(META_PIXEL_ID);
  }, []);
  return <div className="w-full bg-ink-900 font-heading text-bone antialiased selection:bg-gold-400/30 selection:text-gold-100" data-id="element-0" data-mp="31aqfuglwour9">
      <UrgencyBar data-id="element-1" data-mp="2wjqi594yq8np" />
      <main data-id="element-2" data-mp="2wj8cjlweui34">
        <Hero data-id="element-3" data-mp="2wifh3h2wjf0a" />
        <Suspense fallback={<div className="h-32 w-full bg-ink-950" aria-hidden="true" data-id="element-5" data-mp="28ufpyg1ohml6" />} data-id="element-4" data-mp="2whx95n6vnccj">
          <BelowFold data-id="element-6" data-mp="28sl5t3y8dyi5" />
        </Suspense>
      </main>
    </div>;
}